import React from "react"

import { ShiftUpdateCommentDialog } from "@/components/sheriff/shift/ShiftUpdateCommentDialog"

import TopNavigation from "../components/TopNavigation"

interface DashboardLayoutProps {
  children: React.ReactNode
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({ children }) => {
  return (
    <div className="min-h-screen bg-palette-jungleGreen000">
      <TopNavigation />
      <main className="p-4 md:p-6 max-w-[1600px] mx-auto">
        <ShiftUpdateCommentDialog />
        {children}
      </main>
    </div>
  )
}

export default DashboardLayout
